import { SolanaIcon } from 'atoms/icons/SolanaIcon';

import type { Props as PaymentMethodIconProps } from '..';
import { PaymentMethodIcon } from '..';

type Props = Pick<PaymentMethodIconProps, 'size'>;
const iconSize = { xs: 18, lg: 13 };
export const SolanaWalletIcon = ({ size }: Props) => {
  const iconSizeValue = iconSize[size || 'lg'];
  return (
    <PaymentMethodIcon
      size={size}
      backgroundColor="var(--c-blue-400)"
      iconNode={
        <SolanaIcon
          color="var(--c-white)"
          width={iconSizeValue}
          height={iconSizeValue}
        />
      }
    />
  );
};
